import {Text, Modal, ModalOverlay, ModalContent, Center, Flex, Button} from '@chakra-ui/react';
import {BatteryIcon} from '@eksab/features/store/badges/icons';
import {useTranslate} from '@eksab/i18n';
import {useRouter} from 'next/router';

type BuyPowerModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const BuyPowerModal = (props: BuyPowerModalProps) => {
  const t = useTranslate();
  const router = useRouter();

  return (
    <Modal isCentered {...props}>
      <ModalOverlay />
      <ModalContent w="310px" px="4" pt="8" pb="6" alignItems="center">
        <Center boxSize="14" borderColor="#DAE2DA" borderWidth="1px" rounded="full" mb="3">
          <BatteryIcon />
        </Center>
        <Text color="#ABABAB" fontWeight="500" mb="1">
          {t('prize.booster.boost')}
        </Text>
        <Text fontSize="22px" fontWeight="700" textAlign="center" mb="3.5">
          {t('prize.booster.no.powers')}
        </Text>
        <Flex gap="4">
          <Button
            size="lg"
            bgColor="white"
            textColor="black"
            borderRadius="30px"
            borderColor="black"
            border="1px"
            pos="relative"
            fontWeight="700"
            onClick={props.onClose}
            _hover={{}}
            _active={{}}
            textTransform="capitalize"
          >
            {t('app.actions.cancel')}
          </Button>
          <Button textTransform="capitalize" onClick={() => router.push('/store/badges')}>
            {t('app.actions.goto', {location: t('app.store')})}
          </Button>
        </Flex>
      </ModalContent>
    </Modal>
  );
};
